import '@nobleclem/jquery-multiselect';
import bulmaCalendar from 'bulma-calendar';
import $ from 'jquery';

const handleState = el => {
  const elements = document.querySelectorAll(el);

  if (elements.length > 0) {
    elements.forEach(element => {
      if (element.value !== '') {
        element.style.border = '3px solid #000';
      } else {
        element.style.border = '1px solid rgba(0, 0, 0, 0.5)';
      }

      element.addEventListener('change', e => {
        const { value } = e.target;

        if (value !== '') {
          element.style.border = '3px solid #000';
        } else {
          element.style.border = '1px solid rgba(0, 0, 0, 0.5)';
        }
      });
    });
  }
};

const handleMultiSelect = () => {
  if ($('select[multiple]').length > 0) {
    const discipline = $('#edit-discipline');

    $('select[multiple]#edit-discipline').multiselect({
      maxWidth: 770,
      minHeight: 100,
      placeholder: 'Select disciplines (optonal)'
    });

    if (discipline.hasClass('error')) {
      $('.ms-options-wrap').addClass('error');
    } else {
      $('.ms-options-wrap').removeClass('error');
    }
  }
};

const handleCalendar = () => {
  const inputDate = document.querySelectorAll('.event-submission-form input[type="date"]');

  if (inputDate.length > 0) {
    const dateOptions = {
      displayMode: 'default',
      type: 'date',
      color: 'black',
      isRange: false,
      showHeader: false,
      showFooter: false,
      toggleOnInputClick: true,
      showClearButton: true
    };

    // Initialize all input of date type.
    const calendars = bulmaCalendar.attach(
      '.event-submission-form input[type="date"]',
      dateOptions
    );

    // Loop on each calendar initialized
    calendars.forEach(calendar => {
      calendar.on('select', datepicker => {
        const value = datepicker.data.value();
        const { element } = datepicker.data;
        const formatDate = new Date(`${value}`).toISOString().substr(0, 10);
        const wrapper = document.querySelector(
          `#${datepicker.data.id} .datetimepicker-dummy-wrapper`
        );
        const clearBtn = document.querySelector(
          `#${datepicker.data.id} .datetimepicker-clear-button`
        );

        element.value = formatDate;
        element.setAttribute('type', 'date');
        element.setAttribute('value', `${formatDate}`);

        clearBtn.classList.add('is-block');
        wrapper.classList.add('icon-hidden', 'selected', 'placeholder-hidden');
        clearBtn.addEventListener('click', e => {
          e.preventDefault();
          clearBtn.classList.remove('is-block');
          wrapper.classList.remove('placeholder-hidden', 'selected', 'icon-hidden');
          element.value = '';
          element.setAttribute('value', '');
        });
      });
    });
  }
};

export default handleMultiSelect;

handleState('.select, input[type=time]');
handleMultiSelect();
handleCalendar();
